<!-- mapa -->
<div>
    <div 
        id="base-map-content" 
        class="base-map-content" 
        [ngClass]="mapContentClasses"
        [ngStyle]="{ 'bottom.px' : panelHeight }"
        [@segmentChange]="(this.visibleSegments === 1 ? 'left-1' :
                        (this.visibleSegments === 2 ? 'left-2' :
                        (this.visibleSegments === -1 ? 'right-1' :
                        (isMapPanelVisible ? 'right-2' :
                        (this.visibleSegments === 3 ? 'bottom-1' : 'default')))))"
        (@segmentChange.done)="onAnimationFinished($event)"
    >
        <app-loader-map *ngIf="isVisibleMapLoader"></app-loader-map>

        <!-- sterowanie mapą -->
        <tk-map-controls
            (onClickModule$)="onClickModule$.emit($event)"
            [hasAccessToAreas]="hasAccessToAreas"
            [isAreasPanelActive]="isAreasPanelActive"
            [ngClass]="{ 'is-areas-panel-visible': isAreasPanelActive }"
            id="map-controls"
        ></tk-map-controls>

        <!-- obiekt mapy -->
        <tk-map-main-layer></tk-map-main-layer>

        <mapm-minimap-controls></mapm-minimap-controls>

        <app-modal-with-park-information></app-modal-with-park-information>
        <app-modal-event-information></app-modal-event-information>

    </div>

    <app-list-vehicle-bottom></app-list-vehicle-bottom>
</div>
